/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */

import { InlineImage } from "../../components/InlineImage";

function Zonneboiler() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Zonneboiler</h1>
          <p>
            Sinds 23 juni 2009 staat er op onze dakkapel een zonnecollector. De zonnecollector is aangesloten op een boiler en levert ons warm water, zodat de CV ketel daarvoor
            minder gas hoeft te verstoken. Met een zonneboiler zouden we het gasverbruik voor wat betreft het warmwaterverbruik met ruim (50%-60%) moeten kunnen verminderen.
            Volgens de installateur zou de aanschaf in zo'n 7 jaar terugverdiend moeten zijn. Dat lijkt wel heel erg optimistisch, de meeste bronnen hebben het over zo'n 15 jaar.
            Dus dat moet natuurlijk even nagerekend worden...
          </p>

          <h2>Disclaimer</h2>
          <p>
            In tegenstelling tot zonnepanelen is het rendement van een zonneboiler uitermate lastig te meten. Waar bij zonnepanelen de opbrengst precies gemeten wordt, wordt er bij
            een zonneboiler niet gemeten hoeveel het water opgewarmd wordt door de warmtewisselaar in de boiler en al helemaal niet hoeveel gas je daardoor minder verbruikt. Dan
            zijn er ook nog veel zaken die het gasverbruik beïnvloeden (zoals persoonlijke leefomstandigheden en het weer). En uiteraard is de gasprijs ook van enorme invloed.
          </p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h2>Opbrengst en besparing</h2>
          <p>
            Uit eerdere uitgebreide berekeningen bleek dat we gemiddeld genomen per jaar zo'm 160 kuub aan gas besparen door het hebben van een zonneboiler. Je kunt simpelweg dus
            de gasprijs over de afgelopen jaren heen erbij pakken om te zien wat dat heeft bespaard. Dan komen we tot onderstaande tabel:
          </p>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Jaar</th>
                  <th>Bespaard (in m3)</th>
                  <th>Gasprijs (per m3)</th>
                  <th>Totaal bespaard (in €)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2009</td>
                  <td>80</td>
                  <td>€ 0,661297468</td>
                  <td>€ 52,90</td>
                </tr>
                <tr>
                  <td>2010</td>
                  <td>160</td>
                  <td>€ 0,612911392</td>
                  <td>€ 98,07</td>
                </tr>
                <tr>
                  <td>2011</td>
                  <td>160</td>
                  <td>€ 0,641329114</td>
                  <td>€ 102,61</td>
                </tr>
                <tr>
                  <td>2012</td>
                  <td>160</td>
                  <td>€ 0,687025316</td>
                  <td>€ 109,92</td>
                </tr>
                <tr>
                  <td>2013</td>
                  <td>160</td>
                  <td>€ 0,71693038</td>
                  <td>€ 114,71</td>
                </tr>
                <tr>
                  <td>2014</td>
                  <td>160</td>
                  <td>€ 0,705379747</td>
                  <td>€ 112,86</td>
                </tr>
                <tr>
                  <td>2015</td>
                  <td>160</td>
                  <td>€ 0,679620253</td>
                  <td>€ 108,74</td>
                </tr>
                <tr>
                  <td>2016</td>
                  <td>160</td>
                  <td>€ 0,621240876</td>
                  <td>€ 99,40</td>
                </tr>
                <tr>
                  <td>2017</td>
                  <td>160</td>
                  <td>€ 0,648598922</td>
                  <td>€ 103,78</td>
                </tr>
                <tr>
                  <td>2018</td>
                  <td>160</td>
                  <td>€ 0,762751196</td>
                  <td>€ 122,04</td>
                </tr>
                <tr>
                  <td>2019</td>
                  <td>160</td>
                  <td>€ 0,807808</td>
                  <td>€ 129,25</td>
                </tr>
                <tr>
                  <td>2020</td>
                  <td>160</td>
                  <td>€ 0,813993569</td>
                  <td>€ 130,24</td>
                </tr>
                <tr>
                  <td>2021</td>
                  <td>160</td>
                  <td>€ 1,239657763</td>
                  <td>€ 198,35</td>
                </tr>
                <tr>
                  <td>2022</td>
                  <td>160</td>
                  <td>€ 1,917376033</td>
                  <td>€ 306,78</td>
                </tr>
                <tr>
                  <td>2023</td>
                  <td>160</td>
                  <td>€ 1,313953935</td>
                  <td>€ 210,23</td>
                </tr>
                <tr>
                  <td>
                    <b>Totaal</b>
                  </td>
                  <td>
                    <b>2320</b>
                  </td>
                  <td>-</td>
                  <td>
                    <b>€ 1999,88</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="box light">
        <div className="row">
          <h2>Terugverdientijd</h2>
          <p>
            Tot en met het jaar 2023 hebben we dus 2000 euro bespaard. De aanschaf was destijds in totaal 2342 euro. Reparatie in die tijd is ongeveer 370 euro geweest. Dat
            betekent dat de totale kosten dus 2712 euro waren en de opbrengsten 2000, over een periode van 14,5 jaar. Er vanuit gaande dat er niet nog eens een reparatie nodig is,
            en uitgaande van de gemiddelde gasprijs over de looptijd is de terugverdientijd 19,5 jaar. Kanttekening daarbij is wel dat de gasprijs de laatste jaren enorm gestegen
            is en het niet de verwachting is dat die nog heel veel zal dalen. Als we uitgaan van die hogere gasprijs en een besparing van 200 euro per jaar, wat we de afgelopen 3
            jaar hebben gehaald en ook in 2024 zullen halen, dan kom je op een terugverdientijd van 18 jaar. In de berekening van 2012 kwam ik op een terugverdientijd van 26 jaar.
            Maar in die berekening was uiteraard de gestegen gasprijs nog niet meegenomen.
          </p>
        </div>
      </div>
      <div className="box main">
        <div className="left">
          <h3>Hoe werkt een zonneboiler?</h3>
          <p>
            Het principe is bijzonder eenvoudig. Leg in de zomer maar eens een waterpistool of gevulde tuinslang een kwartiertje in de zon. Binnen mum van tijd heb je warm water.
            En dat komt niet door de buitentemperatuur, want het water wordt veel heter dan dat. Op de foto rechts staat een Chinese man die voor zijn moeder een zonneboiler
            gemaakt heeft, met 66 bierflesjes! Dat toont maar weer eens aan hoe eenvoudig het is om water te verwarmen.
          </p>
          <p>
            Het principe van een zonneboiler is niet anders. Hij bestaat uit twee delen; een zonnecollector en een boiler. Leidingen lopen door de zonnecollector (geen
            zonnepanelen!) en boiler en vormen een gesloten systeem; het water wat daar in zit blijft er in. Het water circuleert door de collector en wordt door de zon opgewarmd.
            In de boiler bevindt zich een "warmtewisselaar", ofwel; daar wordt de warmte van dat warme water overgebracht op het koude water in de boiler. De boiler is in verdeeld
            in een x aantal delen, zodat er altijd een deel is met echt heet water.
          </p>
          <p>
            De boiler is vervolgens aangesloten op een CV ketel met NZ keurmerk (Naverwarming Zonneboilers). De CV ketel krijgt heet water binnen en verwarmt alleen na indien
            nodig. In de zomer is dat niet nodig, in de winter wel. Op een warme zomerdag is de temperatuur in de ochtend in de zonneboiler al 80 graden!
          </p>
        </div>
        <div className="right">
          <InlineImage image="energie/zonneboiler1.jpg" />
          <InlineImage image="energie/zonneboiler8.jpg" />
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h3>Onze keus</h3>
          <p>
            Omdat wij eerder al een Remeha Quinta 28c HR CV ketel hadden aangeschaft, was de logische keus de Remeha Zenta. Op het plaatje links staat rechts van de wasmachine de
            boiler en daarnaast hangt de CV ketel. De collectoren staan op het platte dak van de dakkapel.
          </p>
          <p>
            Op de zonneboiler valt niet veel aan te merken. Hij doet zijn werk en doet dat goed. Op zonnige dagen zoals nu is het gasverbruik nihil. Toch verbruikt de CV ketel dus
            nog altijd gas, terwijl dat niet nodig is. Dit komt omdat de ketel wel nog direct aanspringt zodra er warmwatervraag is. Vervolgens komt hij erachter dat opwarmen niet
            nodig is en blijft werkeloos toekijken. Dit verbruik is echter nihil, nog geen 0,15 m3 per dag en dat valt in het niet bij het verbruik nodig voor de verwarming.
          </p>
          <p>
            Dit "sluipverbruik" kan verder gereduceerd worden door een extra kastje tussen de boiler en ketel te plaatsen; de Remeha Gateway. Met dit kastje wordt het ook mogelijk
            de temperatuur van het water in de boiler af te lezen op de kamerthermostaat en allerlei uitgebreide statistieken op te vragen. Zelfs is het daarmee mogelijk, ja nu
            wordt het futuristisch, om de CV ketel op te bellen met je mobiel en de verwarming vast aan te zetten! Het moet toch niet gekker worden! Dit kastje kost rond de 130
            euro en is wellicht de volgende aanschaf.
          </p>
          <p>
            Een klein minpuntje aan de Remeha Zenta is de meter die aangeeft wat de temperatuur van het water in de boiler is. Dit wordt middels 5 LED lampjes aangegeven, waarbij 5
            de maximale temperatuur is zoals op de foto links. Maar ja, 5 lampjes, welke temperatuur hoort daar dan bij? De handleiding zegt daar niets over, op internet is het
            niet te vinden en een mail naar Remeha bleef lang onbeantwoord. Uiteindelijk sprak ik een monteur van Remeha, maar het antwoord was in feite dat het niets zegt over de
            temperatuur maar alles over de 'capaciteit'. Toen ik ophing besefte dat ik nu eigenlijk nog niets wijzer was geworden...
          </p>
        </div>

        <div className="right">
          <InlineImage image="energie/zonneboiler5.jpg" />
          <InlineImage image="energie/zonneboiler8.jpg" />
        </div>
      </div>

      <div className="box main">
        <div className="row">
          <h3>De Techniek</h3>
          <p>
            In 2022 hielt de zonneboiler er opeens mee op, hij verwarmde geen water meer. In eerste instantie belde ik het installatiebedrijf die het systeem destijds had
            geïnstalleerd. De monteur kwam langs, maar al snel bleek die mij niet te kunnen helpen. Een nieuwe zonneboiler installeren geen probleem, maar een oude repareren, daar
            deden ze niet aan. Dus was ik genoodzaakt zelf maar voor monteurtje te spelen, en met succes.
          </p>
          <p>
            De werking van een zonneboiler is eigenlijk relatief eenvoudig. Op <a href="https://www.mijnepb.be/zonneboiler/">deze website</a> staat dat kort en goed uitgelegd. Maar
            een belangrijk detail ontbreekt nog; in de zonnecollector zit een censor die de temperatuur meet. Die censor is aangesloten op de printplaat in de zonneboiler. Ook in
            de boiler zelf zit een censor, die de temperatuur van het water in de boiler meet. Als het water in de boiler nu een bepaalde tijd significant kouder is dan de
            vloeistof (bij ons gewoon water) in de collector, dan gaat de pomp draaien.
          </p>
          <p>
            In ons geval ging de pomp nooit draaien, en dat bleek te komen door een breuk in de kabel naar de collector censor. Dat het daaraan lag was te testen door een
            tijdelijke censor (via marktplaats op de kop getikt) aan te sluiten en die in heet water te houden. Op die manier 'denkt' de zonneboiler dat het water op het dak goed
            warm is, en zou de pomp moeten gaan lopen. En jawel, met die constructie begon de pomp te lopen, wat betekende dat er iets mis was met de censor op de zonnecollector.
            Eenmaal op het dak geklommen was dat duidelijk, want het draadje naar de censor hing gewoon los (los gewaaid na een storm besefte ik me achteraf).
          </p>
        </div>
      </div>
    </div>
  );
}

export default Zonneboiler;
